<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import AdminGeneralSettingsTabs
  from '@modules/general-settings/components/AdminGeneralSettingsTabs/AdminGeneralSettingsTabs.vue';
import {
  TRANSLATION_GROUP_GENERAL_SETTINGS,
} from '@modules/general-settings/constants';

const ready = ref(false);

const route = useRoute();

// hide nav and card wrapper for indirect child routes
const hideTabsAndWrapper = computed(() => !!route.meta?.hideParentModuleWrapper);

onMounted(() => {
  ready.value = true;
});
</script>

<template>
  <div v-data-qa-auto-id="'AdminGeneralSettingsPage'">
    <div v-show="!hideTabsAndWrapper">
      <PCard
        :pt="{ body: { class: 'pb-0' }, title: { class: 'mb-4' } }"
        class="rounded-b-none border-b-0"
      >
        <template #title>
          {{ $getTranslation(TRANSLATION_GROUP_GENERAL_SETTINGS, 'MAIN_TITLE') }}
        </template>
        <template #content>
          <AdminGeneralSettingsTabs />
        </template>
      </PCard>
      <div id="innerContent" />
    </div>
    <div id="outerContent" />
    <Teleport
      v-if="ready"
      :to="!hideTabsAndWrapper ? '#innerContent' : '#outerContent'"
    >
      <RouterView :class="{ 'mb-2 rounded-t-none border-t-0': !hideTabsAndWrapper }" />
    </Teleport>
  </div>
</template>
